import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  templateUrl: './fc-send-email-message-dialog.component.html',
  styleUrls: ['./fc-send-email-message-dialog.component.scss']
})

export class FcSendEmailMessageDialogComponent implements OnInit {
    public title: string;
    public message: string;
    public okText: string;
    public notOkText: string;
    public cancelText: string;
    public inputLabel: string;
    public inputValue: string;

  constructor(
    public readonly ref: MatDialogRef<FcSendEmailMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data
  ) {
    this.title = this.data.title;
    this.message = this.data.message;
    this.okText = this.data.okText;
    this.notOkText = this.data.notOkText;
    this.cancelText = this.data.cancelText;
    this.inputLabel = this.data.inputLabel;
  }

  ngOnInit(): void {
  }

  public confirm(): void {
    this.ref.close({
      sendEmail: true,
      message: this.inputValue
    });
  }

  public notConfirm(): void {
    this.ref.close({
      sendEmail: false,
    });
  }


}
